<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <div class="d-flex flex-row flex-wrap align-items-center justify-content-between mb-3" style="padding: 20px">
            <h3 class="h5 font-weight-semibold">Detail Mapping QR Code</h3>
            <div class="d-flex flex-row align-items-center flex-wrap">
                <div class="mr-3">
                    <span style="font-size: 15px; font-weight: 700;">
                        Total QR: {{ numberWithCommas(config.stock) }}
                    </span>
                </div>
                <div class="mr-3">
                    <MultiSelect
                        v-model="filter.loc_code"
                        :options="options.dealer.map(x => x.code)"
                        :custom-label="opt => options.dealer.find(x => x.code == opt).name.length > 16 ? options.dealer.find(x => x.code == opt).name.substring(0, 16) + '...' : options.dealer.find(x => x.code == opt).name"
                        class="qtrust-select"
                        placeholder="Semua Dealer"
                    >
                    </MultiSelect>
                </div>
                <button
                    type="button"
                    class="btn"
                    style="background-color: white; padding: 4.5px 20px; border-radius: 4px; display: flex; align-items: center; font-size: 14px; cursor: pointer; font-weight: 500; border: 1px solid #e8e8e8;"
                    @click="exportToCSV">
                    Download CSV 
                    <i class="fas fa-file-download ml-2"></i>
                </button>
            </div>
        </div>

        <div class="w-100 overflow-auto">
            <table class="table w-100 qtrust-table">
                <thead>
                    <tr>
                        <th>Nama Dealer</th>
                        <th>Kode Dealer</th>
                        <th>Stock QR</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="data" v-for="dat in data">
                        <td>{{ dat.name ? dat.name : '-' }}</td>
                        <td>{{ dat.kode_dealer ? dat.kode_dealer : '-' }}</td>
                        <td>{{ dat.stock ? dat.stock : '-' }}</td>
                        <td>
                            <div>
                                <svg v-if="$store.state.userData.userData.username === 'qtrusteko' || $store.state.userData.userData.username === 'yosef'  || $store.state.userData.userData.username === 'useradmin'" @click="editQRStock(dat)" class="mr-2 cursor-pointer" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.66602 4.6665H3.99935C3.64573 4.6665 3.30659 4.80698 3.05654 5.05703C2.80649 5.30708 2.66602 5.64622 2.66602 5.99984V11.9998C2.66602 12.3535 2.80649 12.6926 3.05654 12.9426C3.30659 13.1927 3.64573 13.3332 3.99935 13.3332H9.99935C10.353 13.3332 10.6921 13.1927 10.9422 12.9426C11.1922 12.6926 11.3327 12.3535 11.3327 11.9998V11.3332" stroke="#267CE5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10.6667 3.3334L12.6667 5.3334M13.59 4.39007C13.8526 4.12751 14.0001 3.77139 14.0001 3.40007C14.0001 3.02875 13.8526 2.67264 13.59 2.41007C13.3274 2.14751 12.9713 2 12.6 2C12.2287 2 11.8726 2.14751 11.61 2.41007L6 8.00007V10.0001H8L13.59 4.39007Z" stroke="#267CE5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <router-link :to="`/qr-code/dealer-stock/history/${dat.kode_dealer}`">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 8V3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H8" stroke="#F36F21" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0006 14.6668C11.2629 14.6668 10.6341 14.4067 10.1143 13.8866C9.59443 13.3664 9.33434 12.7376 9.33398 12.0002C9.33363 11.2627 9.59372 10.6339 10.1143 10.1138C10.6348 9.59359 11.2636 9.3335 12.0006 9.3335C12.7377 9.3335 13.3667 9.59359 13.8876 10.1138C14.4085 10.6339 14.6684 11.2627 14.6673 12.0002C14.6662 12.7376 14.4062 13.3666 13.887 13.8871C13.3679 14.4076 12.7391 14.6675 12.0006 14.6668ZM12.2673 10.4002V11.8935L13.254 12.8802L12.8806 13.2535L11.734 12.1068V10.4002H12.2673Z" fill="#F36F21"/>
                                        <path d="M4.66602 5.3335H11.3327M4.66602 8.00016H7.33268" stroke="#F36F21" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </router-link>
                            </div>
                        </td>
                        
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3" v-if="data">
            <p class="text-muted mb-0">Showing {{ (config.page-1)*config.limit+1 }}-{{ (config.page-1)*config.limit+data.length }} of {{ config.total }} items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.lastPage)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import * as XLSX from 'xlsx';
    
    export default {
        data () {
            return {
                options : {
                    dealer: this.$store.getters.getDealer(),
                },
                filter : {
                    loc_code: null,
                },
                config : {
                    lastPage: 0,
                    total: 0,
                    stock: 0,
                    page: 1,
                    limit: 5,
                },
                data : null,
            }
        },

        mounted () {
            this.fetchPaginated();
        },
        watch : {
            'filter' : {
                deep: true,
                handler () {
                    this.config.page = 1;
                    this.fetchPaginated();
                }
            },
            'config.page' : {
                handler : 'fetchPaginated'
            },
        },
        methods : {
            goToPage(page) {
                if (page >= 1 && page <= this.config.lastPage) this.config.page = page;
            },
            fetchPaginated () {
                let filter = JSON.parse(JSON.stringify(this.filter));

                this.$http.get(`/api/qrs/qr-stock-list`, {params: {...filter, ...{page: this.config.page, limit: this.config.limit}}})
                .then(async res => {
                    this.data = res.data.data;
                    this.config.lastPage = res.data.meta.lastPage;
                    this.config.total = res.data.meta.total;
                    this.config.stock = res.data.meta.stock;

                    // for cache 
                    this.$http.get(`/api/qrs/qr-stock-list`, {params: {...filter, ...{page: (this.config.page + 1), limit: this.config.limit}}})
                    if (this.config.page == 1) {
                        this.$http.get(`/api/qrs/qr-stock-list`, {params: {...filter, ...{limit: this.config.total}}})
                    }
                })
                .catch((err)=>console.log(err));
            },

            async exportToCSV() {
                let filter = JSON.parse(JSON.stringify(this.filter));

                this.$http.get(`/api/qrs/qr-stock-list`,{params: {...filter, ...{limit: this.config.total}}})
                .then(async res => {
                    let response = res.data.data;
                    try {
                        const customHeaders = {
                            'name': 'Nama Dealer',
                            'kode_dealer': 'Kode Dealer',
                            'stock': 'Stok QR',
                        };
                        
                        const modifiedData = response.map(item => {
                            const newItem = {};
                            for (const [oldKey, newKey] of Object.entries(customHeaders)) {
                                if (item.hasOwnProperty(oldKey)) {
                                    newItem[newKey] = item[oldKey];
                                }
                            }
                            for (const key in item) {
                                if (!customHeaders.hasOwnProperty(key) && key !== 'day_diff') {
                                    newItem[key] = item[key];
                                }
                            }
                            return newItem;
                        });

                        const worksheet = XLSX.utils.json_to_sheet(modifiedData);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                        const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
                        const filename = `stock_qr_code_${timestamp}.csv`;
                        XLSX.writeFile(workbook, filename, { bookType: 'csv' });

                    } catch (error) {
                        console.error('Error fetching data or exporting CSV:', error);
                    }
                })
                .catch((err)=>console.log(err));

            },
            async editQRStock(dat) {
                const swalWithBootstrapButtons = this.$swal.mixin({
                    customClass: {
                        confirmButton: 'ml-3 btn btn-warning d-flex justify-content-end',  
                        cancelButton: 'ml-auto btn outline-0 d-flex justify-content-end',  
                    },
                    buttonsStyling: false  
                });
                
                const swalWithBootstrapButtonsConfirmation = this.$swal.mixin({
                    customClass: {
                        confirmButton: ' btn btn-warning ', 
                        cancelButton: ' btn outline-0 ',  
                    },
                    buttonsStyling: false 
                });

                const { value: formValues } = await swalWithBootstrapButtons.fire({
                    html: `
                        <h3 class="mb-5 text-left">Edit Stok QR</h3>
                        
                        <div class="form-group d-flex align-items-center">
                            <label class="my-0 mr-3" for="kodeDealer">Kode Dealer</label>
                            <p id="kodeDealer" class="m-0 font-weight-bold align-self-center">${dat.kode_dealer}</p>
                        </div>
                        
                        <div class="form-group d-flex align-items-center">
                            <label class="my-0 mr-5" for="stokQr">Stok QR</label>
                            <p id="stokQr" class="m-0 font-weight-bold">${dat.stock}</p>
                        </div>
                        
                        <div class="form-group d-flex align-items-center">
                            <label class="my-0 mr-5">Edit Stok</label>
                            <div class="d-flex align-items-center">
                                <div class="custom-control custom-checkbox mr-3">
                                    <input type="radio" class="custom-control-input" id="penjumlahan" name="editStok" value="penjumlahan" checked>
                                    <label class="custom-control-label" for="penjumlahan">Penjumlahan</label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input type="radio" class="custom-control-input" id="pengurangan" name="editStok" value="pengurangan">
                                    <label class="custom-control-label" for="pengurangan">Pengurangan</label>
                                </div>
                            </div>
                        </div>
                        
                        <div class="form-group d-flex align-items-center">
                            <label class="my-0 mr-5" for="jumlah">Jumlah</label>
                            <input type="text" class="ml-2 form-control" id="jumlah" name="jumlah">
                        </div>
                        
                        <div class="form-group d-flex align-items-center">
                            <label class="my-0 mr-5" for="alasan">Alasan</label>
                            <textarea id="alasan" name="alasan" class="ml-2 form-control" rows="3"></textarea>
                        </div>
                    `,
                    showCancelButton: true,
                    confirmButtonText: 'Edit',
                    cancelButtonText: 'Batal',
                    reverseButtons: true,
                    preConfirm: () => {
                        const isAddition = document.getElementById('penjumlahan').checked;
                        const isSubtraction = document.getElementById('pengurangan').checked;
                        const jumlah = parseInt(document.getElementById('jumlah').value, 10);
                        const alasan = document.getElementById('alasan').value;

                        if (isNaN(jumlah) || jumlah < 1) {
                            this.$swal.showValidationMessage('Jumlah harus lebih dari 0.');
                            return false; 
                        }

                        if (!alasan) {
                            this.$swal.showValidationMessage('Alasan harus diisi.');
                            return false; 
                        }

                        return { isAddition, isSubtraction, jumlah, alasan };
                    }
                });

                if (formValues) {
                    console.log('Form Values:', formValues);

                    const result = await swalWithBootstrapButtonsConfirmation.fire({
                        html: `
                            <h3 class="mb-5 text-left">Konfirmasi Edit QR</h3>
                            <svg class="mb-3" width="124" height="112" viewBox="0 0 124 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M53.493 2.18918C61.9236 -2.48607 72.6478 0.58571 77.359 8.94096L122.425 87.1547C123.417 89.4893 123.851 91.3877 123.975 93.3597C124.223 97.9674 122.611 102.446 119.45 105.893C116.288 109.327 112.011 111.354 107.362 111.6H16.6092C14.6875 111.483 12.7659 111.047 10.9682 110.371C1.97967 106.747 -2.3596 96.5482 1.29778 87.7077L46.6741 8.88567C48.2239 6.11492 50.5795 3.72507 53.493 2.18918ZM61.9856 76.0902C59.0101 76.0902 56.5305 78.5476 56.5305 81.5027C56.5305 84.4454 59.0101 86.909 61.9856 86.909C64.9611 86.909 67.3786 84.4454 67.3786 81.4351C67.3786 78.4923 64.9611 76.0902 61.9856 76.0902ZM61.9856 37.7604C59.0101 37.7604 56.5305 40.1503 56.5305 43.1054V60.4855C56.5305 63.4344 59.0101 65.898 61.9856 65.898C64.9611 65.898 67.3786 63.4344 67.3786 60.4855V43.1054C67.3786 40.1503 64.9611 37.7604 61.9856 37.7604Z" fill="#F36F21"/>
                            </svg>
                            <p>Apakah anda yakin edit stok QR untuk dealer ${dat.kode_dealer}</p>
                        `,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Ya',
                        cancelButtonText: 'Batal',
                        reverseButtons: true,
                    });

                    console.log('SweetAlert Result:', result);

                    if (result.value) {
                        const { isAddition, jumlah, alasan } = formValues;
                        const type = isAddition ? 1 : -1;  

                        try {
                            const response = await this.$http.post(`/api/qrs/qr-stock-adjust`, new URLSearchParams({
                                kode_dealer: dat.kode_dealer,
                                type: type,
                                qty: jumlah,
                                reason: alasan
                            }), {
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            });

                            if (response.data.status === 'success') {
                                console.log('Stock updated successfully');
                                window.location.href = `/qr-code/dealer-stock/history/${dat.kode_dealer}`;
                            } else {
                                console.log('Error: Stock update failed');
                            }
                        } catch (error) {
                            console.error('Error updating stock:', error);
                        }
                    } else {
                        console.log('User canceled the update');
                    }
                } else {
                    console.log('Form values were not returned');
                }
            }

        }
    }
</script>

<style scoped>
    .qtrust-table > thead > tr > th {
        text-align: left;
        border-top: 2px solid #F3F3F3;
        border-bottom: 2px solid #F3F3F3;
        padding: 8px 16px;
    }

    .qtrust-table > tbody > tr > td {
        text-align: left;
        padding: 8px 16px;
        border-bottom: 1px solid #F3F3F3;
    }

    .cursor-pointer {
        cursor: pointer;
    }
</style>